var _metadata, _sodipodiNamedview, _defs, _polygon, _path, _polygon2, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _path8, _path9, _circle2, _path10, _path11, _path12, _path13, _path14, _circle3, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _circle4, _path22, _circle5, _path23, _circle6, _path24, _polygon3, _path25, _polygon4, _path26, _g, _path27, _circle7, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _polygon5, _polygon6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgA3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    inkscapeVersion: "1.0 (4035a4fb49, 2020-05-01)",
    sodipodiDocname: "a3.svg",
    viewBox: "0 0 898.97836 570.08",
    height: 570.08,
    width: 898.97836,
    "data-name": "Layer 1",
    id: "e415e4e1-8870-48b5-9940-d02b43ac290b",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata120"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    "inkscapeCurrent-layer": "e415e4e1-8870-48b5-9940-d02b43ac290b",
    "inkscapeWindow-maximized": 1,
    "inkscapeWindow-y": -9,
    "inkscapeWindow-x": -9,
    inkscapeCy: 285.04001,
    inkscapeCx: 449.48917,
    inkscapeZoom: 1.3437476,
    showgrid: "false",
    id: "namedview118",
    "inkscapeWindow-height": 1001,
    "inkscapeWindow-width": 1920,
    inkscapePageshadow: 2,
    inkscapePageopacity: 0,
    guidetolerance: 10,
    gridtolerance: 10,
    objecttolerance: 10,
    borderopacity: 1,
    bordercolor: "#666666",
    pagecolor: "#ffffff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs9"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1, 0, 0, -1, -88.27, 870.92)",
    y2: 538.14802,
    x2: 278.84756,
    y1: 537.968,
    x1: 278.84756,
    id: "b3748f69-0e41-4ff3-90ef-d3524a6a40c3"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop2",
    stopOpacity: 0.25,
    stopColor: "gray",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop4",
    stopOpacity: 0.12,
    stopColor: "gray",
    offset: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop6",
    stopOpacity: 0.1,
    stopColor: "gray",
    offset: 1
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "polygon11",
    fill: "#a0616a",
    points: "828.975 558.002 816.367 558.002 810.367 460 828.975 460 828.975 558.002"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path13",
    fill: "#2f2e41",
    d: "M807.3619,554.39947h24.31453a0,0,0,0,1,0,0v15.30914a0,0,0,0,1,0,0H792.05278a0,0,0,0,1,0,0v0A15.30912,15.30912,0,0,1,807.3619,554.39947Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "polygon15",
    fill: "#a0616a",
    points: "891.874 544.746 880.291 549.724 830.577 457.415 847.673 450.068 891.874 544.746"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path17",
    fill: "#2f2e41",
    transform: "translate(-351.32334 299.56174) rotate(-23.2563)",
    d: "M1023.762,712.53021h24.31453a0,0,0,0,1,0,0v15.30914a0,0,0,0,1,0,0h-39.62365a0,0,0,0,1,0,0v0A15.30913,15.30913,0,0,1,1023.762,712.53021Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path19",
    fill: "#e6e6e6",
    transform: "translate(-150.51082 -164.96)",
    d: "M858.76748,294.64164H640.33271a6.51767,6.51767,0,0,1-6.51015-6.51015V171.47015a6.51767,6.51767,0,0,1,6.51015-6.51015H858.76748a6.51766,6.51766,0,0,1,6.51014,6.51015V288.13149A6.51766,6.51766,0,0,1,858.76748,294.64164Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "circle21",
    fill: "#fff",
    r: 24.01862,
    cy: 57.6184,
    cx: 527.12896
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path23",
    fill: "#fff",
    transform: "translate(-150.51082 -164.96)",
    d: "M832.30168,201.07173H734.23584a3.67243,3.67243,0,0,1,0-7.34486h98.06584a3.67243,3.67243,0,0,1,0,7.34486Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path25",
    fill: "#fff",
    transform: "translate(-150.51082 -164.96)",
    d: "M780.96358,217.86019H734.23584a3.67243,3.67243,0,0,1,0-7.34486h46.72774a3.67243,3.67243,0,1,1,0,7.34486Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "path27",
    fill: "#fff",
    transform: "translate(-150.51082 -164.96)",
    d: "M813.87408,234.64117H734.23584a3.67243,3.67243,0,0,1,0-7.34486h79.63824a3.67243,3.67243,0,0,1,0,7.34486Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path29",
    fill: "#fff",
    transform: "translate(-150.51082 -164.96)",
    d: "M832.30168,251.42216H734.23584a3.67243,3.67243,0,0,1,0-7.34486h98.06584a3.67243,3.67243,0,0,1,0,7.34486Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "path31",
    fill: "#fff",
    transform: "translate(-150.51082 -164.96)",
    d: "M829.2306,281.78215H812.99337a6.74351,6.74351,0,1,1,0-13.487H829.2306a6.7435,6.7435,0,0,1,0,13.487Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "path33",
    fill: "#f2f2f2",
    transform: "translate(-150.51082 -164.96)",
    d: "M533.88344,305.50694H381.36687a4.55079,4.55079,0,0,1-4.54555-4.54554V219.50555a4.55079,4.55079,0,0,1,4.54555-4.54555H533.88344a4.55079,4.55079,0,0,1,4.54555,4.54555V300.9614A4.55079,4.55079,0,0,1,533.88344,305.50694Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "circle35",
    fill: "#fff",
    r: 16.7704,
    cy: 90.2306,
    cx: 256.90477
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "path37",
    fill: "#fff",
    transform: "translate(-150.51082 -164.96)",
    d: "M515.40436,240.1741h-68.472a2.56418,2.56418,0,0,1,0-5.12836h68.472a2.56418,2.56418,0,1,1,0,5.12836Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "path39",
    fill: "#fff",
    transform: "translate(-150.51082 -164.96)",
    d: "M479.55883,251.89623H446.93236a2.56419,2.56419,0,0,1,0-5.12837h32.62647a2.56419,2.56419,0,0,1,0,5.12837Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "path41",
    fill: "#fff",
    transform: "translate(-150.51082 -164.96)",
    d: "M502.53776,263.61313h-55.6054a2.56419,2.56419,0,0,1,0-5.12837h55.6054a2.56419,2.56419,0,0,1,0,5.12837Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "path43",
    fill: "#fff",
    transform: "translate(-150.51082 -164.96)",
    d: "M515.40436,275.33h-68.472a2.56419,2.56419,0,0,1,0-5.12837h68.472a2.56419,2.56419,0,1,1,0,5.12837Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "path45",
    fill: "#fff",
    transform: "translate(-150.51082 -164.96)",
    d: "M513.26006,296.52813H501.92283a4.70849,4.70849,0,1,1,0-9.417h11.33723a4.70849,4.70849,0,1,1,0,9.417Z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a5e40a",
      fillOpacity: 1
    },
    id: "path47",
    fill: "#fce40a",
    transform: "translate(-150.51082 -164.96)",
    d: "M794.77762,431.64164H509.57743a8.50981,8.50981,0,0,1-8.5-8.5V270.82231a8.50981,8.50981,0,0,1,8.5-8.5H794.77762a8.50981,8.50981,0,0,1,8.5,8.5V423.14164A8.50981,8.50981,0,0,1,794.77762,431.64164Z"
  }), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "circle49",
    fill: "#fff",
    r: 31.36,
    cy: 172.59199,
    cx: 407.77673
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "path51",
    fill: "#fff",
    transform: "translate(-150.51082 -164.96)",
    d: "M760.22245,309.47172h-128.04a4.79492,4.79492,0,0,1,0-9.58984h128.04a4.79492,4.79492,0,1,1,0,9.58984Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "path53",
    fill: "#fff",
    transform: "translate(-150.51082 -164.96)",
    d: "M693.19266,331.39164H632.18241a4.79492,4.79492,0,0,1,0-9.58984h61.01025a4.79492,4.79492,0,1,1,0,9.58984Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "path55",
    fill: "#fff",
    transform: "translate(-150.51082 -164.96)",
    d: "M736.16239,353.3018h-103.98a4.79492,4.79492,0,0,1,0-9.58985h103.98a4.79492,4.79492,0,0,1,0,9.58985Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "path57",
    fill: "#fff",
    transform: "translate(-150.51082 -164.96)",
    d: "M760.22245,375.212h-128.04a4.79492,4.79492,0,0,1,0-9.58984h128.04a4.79492,4.79492,0,1,1,0,9.58984Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "path59",
    fill: "#fff",
    transform: "translate(-150.51082 -164.96)",
    d: "M756.21268,414.8516H735.01249a8.80469,8.80469,0,1,1,0-17.60937h21.20019a8.80469,8.80469,0,1,1,0,17.60937Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "path61",
    fill: "#2f2e41",
    transform: "translate(-150.51082 -164.96)",
    d: "M1044.23753,625.11191s-24.99-127.42-28.93-138.16c-2.17-5.87-3.6-10.14-3.6-10.14l-73.44,4.2-.6,5.94-9.9,149.02s3.5-9.47,6.64-11.21,2.81,11.19,2.81,11.19"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a5e40a",
      fillOpacity: 1
    },
    id: "path63",
    fill: "#fce40a",
    transform: "translate(-150.51082 -164.96)",
    d: "M938.83041,480.96h64.27889c-1.80447-6.45886,0-12.44533,2.57891-17.03778a37.63024,37.63024,0,0,1,6.72993-8.73573l.44143-.395,22.45889-4.97967,1.20813-.26331s.17811-40.80548-14.26525-46.4047a88.30853,88.30853,0,0,1-22.13717-12.36359,3.97108,3.97108,0,0,0-2.32327-.85113L966.27231,388.775a4.02042,4.02042,0,0,0-2.671.89766c-5.21235,4.19136-21.78866,12.605-30.70136,17.00647a6.78648,6.78648,0,0,0-3.21916,8.80157c3.55913,8.17215,9.60641,21.83936,10.24161,21.83936C940.82849,437.3201,938.83041,480.96,938.83041,480.96Z"
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "path65",
    fill: "#f6f8fb",
    transform: "translate(-150.51082 -164.96)",
    d: "M982.4099,414.77813l30.2085,78.11493s-20.42349,4.70929-40.12211-19.36619l-7.109-15.51656-16.01691-59.13808Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "circle67",
    fill: "#2f2e41",
    r: 41,
    cy: 167,
    cx: 839.91817
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "path69",
    fill: "#a0616a",
    transform: "translate(-150.51082 -164.96)",
    d: "M964.42081,469.32866a8.36966,8.36966,0,0,0,9.6548,2.54688l21.96459,8.59538,7.31829-16.54628-24.749-3.19612a8.36532,8.36532,0,1,0-14.18864,8.60014Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "circle71",
    fill: "#a0616a",
    r: 26.2388,
    cy: 191.64459,
    cx: 833.70128
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "path73",
    fill: "#2f2e41",
    transform: "translate(-150.51082 -164.96)",
    d: "M1021.11138,339.22567a90.60939,90.60939,0,0,1-45.54214,11.00377c-6.08348-.15784-12.7862-1.26445-16.63892-5.9751-4.34716-5.31518-3.25936-13.62.93393-19.05742s10.75384-8.50273,17.29812-10.58149c6.192-1.96687,12.82694-3.23364,19.17669-1.85868a23.879,23.879,0,0,1,17.30437,31.72434"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "circle75",
    fill: "#2f2e41",
    r: 23,
    cy: 138,
    cx: 868.91817
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a5e40a",
      fillOpacity: 1
    },
    id: "path77",
    fill: "#fce40a",
    transform: "translate(-150.51082 -164.96)",
    d: "M1027.6669,438.70632l8.8519,10.84222,1.80442,29.42889s2.32333,14.9855-14.80738,11.37659-39.178-10.62691-39.178-10.62691,11.73167-17.00527,6.49642-21.87653l24.55765,7.94581s4.151-.90611.89833-4.515-3.82575-10.11424-3.82575-10.11424Z"
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "path79",
    fill: "#a0616a",
    transform: "translate(-150.51082 -164.96)",
    d: "M982.21315,464.18566a8.36964,8.36964,0,0,1-9.49217-3.09844l-23.11436-4.69576,2.829-17.8699,22.5242,10.742a8.36532,8.36532,0,1,1,7.25331,14.92211Z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a5e40a",
      fillOpacity: 1
    },
    id: "path81",
    fill: "#fce40a",
    transform: "translate(-150.51082 -164.96)",
    d: "M951.7074,422.86452s-4.0107,5.15387-8.701,6.42084-1.69485,4.28016-1.69485,4.28016l24.94024,6.64822c-7.0406,1.25183-6.4112,21.90165-6.4112,21.90165s-22.328-6.06569-38.67649-12.32781-6.26679-17.59012-6.26679-17.59012l17.48157-23.74259,13.3181-4.30559Z"
  }), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "polygon83",
    fill: "#ffb8b8",
    points: "36.427 538.404 48.46 543.575 74.133 499.623 56.374 491.99 36.427 538.404"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "path85",
    fill: "#2f2e41",
    transform: "translate(-45.69774 1285.10825) rotate(-156.7437)",
    d: "M181.02457,706.29787h41.16277a0,0,0,0,1,0,0v15.9038a0,0,0,0,1,0,0H196.3337a15.30912,15.30912,0,0,1-15.30912-15.30912v-.59467A0,0,0,0,1,181.02457,706.29787Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    id: "polygon87",
    fill: "#ffb8b8",
    points: "119.429 553.213 132.527 553.213 138.76 502.695 119.429 502.695 119.429 553.213"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "path89",
    fill: "#2f2e41",
    transform: "translate(424.91914 1279.8063) rotate(-180)",
    d: "M267.13359,714.43125h41.16277a0,0,0,0,1,0,0V730.335a0,0,0,0,1,0,0H282.44272a15.30912,15.30912,0,0,1-15.30912-15.30912v-.59467A0,0,0,0,1,267.13359,714.43125Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g93",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "path91",
    fill: "url(#b3748f69-0e41-4ff3-90ef-d3524a6a40c3)",
    transform: "translate(-150.51082 -164.96)",
    d: "M190.20756,332.752l.74.16A1,1,0,0,0,190.20756,332.752Z"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "path95",
    fill: "#2f2e41",
    transform: "translate(-150.51082 -164.96)",
    d: "M292.06023,672.93572l-30.12646,1.1947c-7.355-4.94491-30.1888-121.7524-30.1888-121.7524.15582.90379-2.85682,115.9349-2.85682,115.9349H196.47624l-15.924-179.37916,17.57573,7.07661s80.48068-6.526,84.23093-1.88239C283.14836,495.64364,292.06023,672.93572,292.06023,672.93572Z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "circle97",
    fill: "#ffb8b8",
    r: 26.2388,
    cy: 170.64459,
    cx: 73.70128
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "path99",
    fill: "#ffb8b8",
    transform: "translate(-150.51082 -164.96)",
    d: "M268.6734,542.73792a8.69476,8.69476,0,0,1-.11437-10.37229l-3.082-24.30809,18.52576-3.17117L280.939,530.62856a8.69026,8.69026,0,1,1-12.26557,12.10936Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "path101",
    fill: "#e1e7ef",
    transform: "translate(-150.51082 -164.96)",
    d: "M228.18729,318.00541l.57843.125A.80639.80639,0,0,0,228.18729,318.00541Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "path103",
    fill: "#2f2e41",
    transform: "translate(-150.51082 -164.96)",
    d: "M215.78666,325.77008c5.71267,1.248,11.52591,2.43843,17.36042,2.05043s11.78512-2.54818,15.57383-7.00214,4.83653-11.44718,1.47377-16.23089c-3.99859-5.68821-12.01686-6.37017-18.96838-6.51433l-21.90424-.45424c-4.32789-.08975-8.86908-.132-12.70208,1.87969-6.65926,3.495-8.95812,11.98392-8.825,19.5034a49.88262,49.88262,0,0,0,18.3289,37.425c2.96443,2.38583,7.84489,4.19992,10.10452,1.13821.98523-1.335-8.63454-16.69875-8.66229-18.35767-.16134-9.6433,9.30982-5.7155,9.14849-15.35881"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "path105",
    fill: "#e6e6e6",
    transform: "translate(-150.51082 -164.96)",
    d: "M190.50036,495.55215c24.96875,19.527,52.5296,29.36959,83.7281,25.6183-13.17649-46.26435-17.08476-92.17832-4.37386-137.464l-26.24313-11.8719L207.99578,369.96l-21.44014,6.30593a14.33611,14.33611,0,0,0-10.284,14.0352C177.02871,428.9216,180.5775,465.065,190.50036,495.55215Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "path107",
    fill: "#e6e6e6",
    transform: "translate(-150.51082 -164.96)",
    d: "M269.22977,524.91947l16.24575,1.87451L281.6717,406.15852a28.07985,28.07985,0,0,0-17.26595-25.03489l-5.7982-2.41592,1.56209,56.54771Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "path109",
    fill: "#ffb8b8",
    transform: "translate(-150.51082 -164.96)",
    d: "M189.59755,516.78244a8.69477,8.69477,0,0,1-4.20992-9.4802l-12.45044-21.10376,15.75824-10.24394,7.37393,24.853a8.69026,8.69026,0,1,1-6.47181,15.97488Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "path111",
    fill: "#e6e6e6",
    transform: "translate(-150.51082 -164.96)",
    d: "M183.00232,507.42405l15.21029-11.21838-16.46-48.76593,5.936-71.54379h0c-12.8946,4.05258-26.74,14.939-29.02045,28.26164l-8.15733,47.656Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    id: "polygon113",
    opacity: 0.2,
    points: "38.925 270.993 32.23 297.771 47.422 335.77 35.835 299.831 38.925 270.993"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    id: "polygon115",
    opacity: 0.2,
    points: "105.236 284.875 110.404 342.256 101.653 285.275 105.236 284.875"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA3);
export default __webpack_public_path__ + "static/media/a3.6fe63b7cd3744d26949b7dd40600ff7a.svg";
export { ForwardRef as ReactComponent };